export default __webpack_public_path__ + "static/media/work_web-xs@2x.400008cc.webp";